/**
 * Build the text shown for a question that has exactly one part.
 *
 * A one-part question carries its wording in two places. When the matrix file follows
 * the template the task sits at the end of the question text and the sub-question is a
 * copy of it, so either value alone is complete. When the file puts the task in the
 * `sub_questions` column instead, the question holds only the scenario and the task
 * lives on the sub-question -- showing one of them drops half the question.
 *
 * Show both, unless they are the same text.
 */
export function buildSingleSubQuestionText(
  questionText?: string | null,
  subQuestionText?: string | null,
): string {
  const stem = (questionText ?? '').trim()
  const task = (subQuestionText ?? '').trim()

  if (!task || task === stem) return stem
  if (!stem) return task

  return `${stem}\n\n${task}`
}
